export const ORDER_STATUS = {
    PROCESSED: 3,
    PROCESSED_ALT: 5,
    CANCELED: 6,
    CANCELED_ALT: 7,
    UNDER_REVIEW: 8,
    PROCESSING: 9,
    REVISION_IN_PROGRESS: 10,
    REJECTED: 11,
    COMPLETED: 12,
    COMPLETEDMANUALLY: 13,
  } as const;

  export type OrderStatus = typeof ORDER_STATUS[keyof typeof ORDER_STATUS];